var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "./NodeIcon.css";
function sharedSvgProps(_a) {
    var style = _a.style, iconColor = _a.iconColor;
    return {
        className: "qg-icon",
        style: __assign({ color: iconColor }, style),
    };
}
function DefaultIcon(p) {
    return (_jsx("svg", __assign({ viewBox: "-7 -7 14 14" }, sharedSvgProps(p), { children: _jsx("circle", { r: "5", fill: "currentColor" }) })));
}
function RunQueryIcon(p) {
    return (_jsxs("svg", __assign({ viewBox: "-7 -7 14 14" }, sharedSvgProps(p), { children: [_jsx("circle", { r: "6", fill: "currentColor" }), _jsx("path", { d: "M-2.5,-3.5L4,0L-2.5,3.5 z", fill: "#fff" })] })));
}
function GroupByIcon(p) {
    return (_jsx("svg", __assign({ viewBox: "0 0 14 14" }, sharedSvgProps(p), { children: _jsx("path", { d: "m 12.791493,0.09859908 0.07435,3.95594402 h -0.397475 c -0.02719,-0.65226 -0.166472,-1.17541 -0.417854,-1.5695 -0.251404,-0.3940699 -0.55885,-0.6437599 -0.92234,-0.7490799 -0.363511,-0.10524 -0.888379,-0.15806 -1.5746055,-0.15806 H 5.6807598 l -0.023394,9.8231058 c -4.8e-6,0.91046 0.1171977,1.48798 0.3516101,1.73259 0.2344018,0.24459 0.7762555,0.38048 1.6255615,0.40765 v 0.3771 H 1.7030209 v -0.3771 c 0.8560938,-0.0272 1.4030432,-0.16306 1.6408499,-0.40765 0.2378018,-0.24461 0.3567027,-0.82213 0.3567059,-1.73259 v -8.78515 c -3.2e-6,-0.91044 -0.1189041,-1.4879799 -0.3567059,-1.73258992 -0.2378067,-0.24457 -0.7847561,-0.38046 -1.6408499,-0.40765 v -0.3771 z", fill: "currentColor", stroke: "inherit" }) })));
}
function SortIcon(p) {
    return (_jsxs("svg", __assign({ viewBox: "-9 -8 18 18" }, sharedSvgProps(p), { children: [_jsx("rect", { x: -8, y: -8, width: 16, height: "16", fill: "#fff", stroke: "none" }), _jsx("path", { d: "M6,3 L6,6 L-7,6 L-7,3 Z", fill: "currentColor" }), _jsx("path", { d: "M0,-2 L0,1 L-7,1 L-7,-2 Z", fill: "currentColor" }), _jsx("path", { d: "M-3,-7 L-3,-4 L-7,-4 L-7,-7 Z", fill: "currentColor" }), _jsx("path", { d: "M6,-7 L6,-2 L8,-2 L5.7,0.77 L5.3,0.77 L3,-2 L5,-2 L5,-7 Z", fill: "currentColor" })] })));
}
function FilterIcon(p) {
    return (_jsx("svg", __assign({ viewBox: "-7 -7 14 14" }, sharedSvgProps(p), { children: _jsx("path", { d: "M-6,-6 L6,-6 L0.8,0 L0.8,5 L-0.8,7 L-0.8,0 Z", fill: "currentColor" }) })));
}
function createJoinIcon(joinFills) {
    return function JoinIcon(p) {
        // Join symbols are just 2 overlapped circles for the most part.
        var radius = 6.0;
        var leftOffset = -3.0;
        var rightOffset = 3.0;
        return (_jsxs("svg", __assign({ viewBox: "-10 -7 20 14" }, sharedSvgProps(p), { children: [_jsx("circle", { r: radius, cx: leftOffset, stroke: "none", fill: joinFills.left ? "currentColor" : "#fff" }), _jsx("circle", { r: radius, cx: rightOffset, stroke: "none", fill: joinFills.right ? "currentColor" : "#fff" }), _jsx("clipPath", { id: "join-clip", children: _jsx("circle", { r: radius, cx: leftOffset }) }), _jsx("circle", { r: radius, cx: rightOffset, clipPath: "url(#join-clip)", stroke: "none", fill: joinFills.center ? "currentColor" : "#fff" }), _jsx("circle", { r: radius, cx: leftOffset, fill: "none" }), _jsx("circle", { r: radius, cx: rightOffset, fill: "none" })] })));
    };
}
var InnerJoinIcon = createJoinIcon({ left: false, center: true, right: false });
var LeftJoinIcon = createJoinIcon({ left: true, center: true, right: false });
var RightJoinIcon = createJoinIcon({ left: false, center: true, right: true });
var FullJoinIcon = createJoinIcon({ left: true, right: true, center: true });
function createTableIcon(labelText) {
    return function TableIcon(p) {
        var tableRowWidth = 5.2;
        var tableRowHeight = 2.8;
        var tableWidth = tableRowWidth * 3;
        var tableHeight = tableRowHeight * 4;
        var tableStartLeft = -tableWidth / 2;
        var tableStartTop = -tableHeight / 2;
        var content;
        if (labelText) {
            content = (_jsx("text", { className: "qg-table-text", y: tableRowHeight + 0.8 /* stroke-width */ / 2, children: labelText }));
        }
        else {
            content = (_jsxs(_Fragment, { children: [_jsx("rect", { className: "qg-table-border", x: tableStartLeft, width: tableWidth, y: 0, height: tableRowHeight, fill: "none" }), _jsx("rect", { className: "qg-table-border", x: -tableRowWidth / 2, width: tableRowWidth, y: tableStartTop + tableRowHeight, height: tableHeight - tableRowHeight, fill: "none" })] }));
        }
        return (_jsxs("svg", __assign({ viewBox: "-10 -7 20 14" }, sharedSvgProps(p), { children: [_jsx("rect", { x: tableStartLeft, width: tableWidth, y: tableStartTop, height: tableHeight, fill: "#fff" }), _jsx("rect", { x: tableStartLeft, width: tableWidth, y: tableStartTop, height: tableRowHeight, fill: "currentColor" }), content] })));
    };
}
var TableIcon = createTableIcon();
var ConstTableIcon = createTableIcon("cnst");
var VirtualTableIcon = createTableIcon("dmv");
var TempTableIcon = createTableIcon("tmp");
export function NodeIcon(_a) {
    var icon = _a.icon, rest = __rest(_a, ["icon"]);
    var iconTypes = {
        "run-query-symbol": RunQueryIcon,
        "filter-symbol": FilterIcon,
        "groupby-symbol": GroupByIcon,
        "sort-symbol": SortIcon,
        "inner-join-symbol": InnerJoinIcon,
        "left-join-symbol": LeftJoinIcon,
        "right-join-symbol": RightJoinIcon,
        "full-join-symbol": FullJoinIcon,
        "table-symbol": TableIcon,
        "temp-table-symbol": TempTableIcon,
        "virtual-table-symbol": VirtualTableIcon,
        "const-table-symbol": ConstTableIcon,
    };
    var SelectedIcon = icon ? iconTypes[icon] : DefaultIcon;
    return _jsx(SelectedIcon, __assign({}, rest));
}
